import React from 'react';
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";

const EmailConfurmacion = () => {

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
                        <div className="text-700 text-center">
                            <span className="p-3 shadow-2 mb-3 inline-block surface-card" style={{ borderRadius: '10px' }}>
                                <i className="pi pi-envelope text-4xl text-blue-500 text-primary"></i>
                            </span>
                            <div className="text-900 text-primary font-bold text-5xl mb-3">¡Listo! Revise su correo.</div>
                            <div className="text-700 text-2xl mb-5">
                                Esta acción requiere una validación de correo.<br />
                                Por favor revise su buzón de correo, incluida la bandeja de correos no deseados o Spam y siga las instrucciones enviadas.
                            </div>
                            <Link to="/login">
                                <Button label="Ingresar" className="p-button-rounded"></Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmailConfurmacion;